import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  WORKSPACE_MEMBERS,
  WORKSPACE_ANALYTICS,
  Member,
  WORKSPACE,
} from "./types";
import {
  fetchWorkspaceMembers,
  deleteWorkspaceMember,
  fetchWorkspaceAnalytics,
  fetchWorkspace,
  updateWidgetCustomisation,
} from "./requests";
import { DataPoint } from "@/types/workspace";
import { UserWorkspace } from "@/types/auth";
import { toast } from "sonner";

export const useWorkspaceMembers = () =>
  useQuery<Member[]>({
    queryKey: WORKSPACE_MEMBERS,
    queryFn: fetchWorkspaceMembers,
  });

export const useGetSingleWorkspace = () =>
  useQuery<UserWorkspace>({
    queryKey: WORKSPACE,
    queryFn: fetchWorkspace,
  });

export const useWorkspaceAnalytics = () =>
  useQuery<{ graph: DataPoint[]; totals: DataPoint }>({
    queryKey: WORKSPACE_ANALYTICS,
    queryFn: fetchWorkspaceAnalytics,
  });

export const useDeleteWorkspaceMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteWorkspaceMember,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WORKSPACE_MEMBERS });
    },
  });
};

export const useUpdateWidgetCustomisation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateWidgetCustomisation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WORKSPACE });
      toast.success("Widget customisation updated");
    },
  });
};
